import request from './base/http';
export default {
  // 获取答题卡类型
  Login(data) {
    return request({
      method: 'post',
      url: '/appCenter/auth/login',
      data,
    });
  },
  getUserInfo() {
    return request({
      method: 'get',
      url: '/appCenter/apps/getUserInfo',
    });
  },
};
